var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header-mobile__banner__col"},[_c('button',{staticClass:"s-header-mobile__back-button",attrs:{"aria-label":_vm.labels.ariaLabelGoBack},on:{"click":_vm.goBack,"blur":function($event){return _vm.mightTabOutOfApp()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }